import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isAdminSession } from 'utils/authGuard';

// Gates every route nested under it: no valid token, or a token whose role
// isn't "Admin", is redirected to login before any dashboard data can render.
// Checked on every render (not just once at module load) so logout/expiry
// during a session takes effect immediately, not just after a full reload.
const RequireAdmin = () => {
    const location = useLocation();

    if (!isAdminSession()) {
        return <Navigate to="/pages/login/login3" state={{ from: location }} replace />;
    }

    return <Outlet />;
};

export default RequireAdmin;
